import React from 'react'
import { InterstitialClearscoreLogo, ZutoLogoSmallDesktop } from '@zuto/icons'
import BrandStripHeader from '@zuto/atoms/src/Mui/Header/BrandStripHeader'

const PartnerBrandHeader: React.FC = () => {
  return (
    <BrandStripHeader
      primaryLogo={
        <ZutoLogoSmallDesktop aria-label="Zuto" data-testid="zuto-logo" />
      }
      partnerLogo={
        <InterstitialClearscoreLogo
          aria-label="ClearScore"
          data-testid="clearscore-logo"
        />
      }
    />
  )
}

export default PartnerBrandHeader
